<div class="flex flex-col items-center justify-center flex-auto min-w-0" *transloco="let t; read: 'pages.404'">

  <!-- Main -->
  <div class="items-center justify-center px-0 py-6 sm:p-10">

    <!-- CONTENT GOES HERE -->
    <div class="flex flex-col h-40 min-h-40 max-h-40 w-full items-center justify-center">
      <mat-icon
        class="icon-size-10 bg-primary-100 rounded-full p-2"
        [color]="'primary'"
        [svgIcon]="'heroicons_outline:cloud'">
      </mat-icon>
      <div class="text-4xl mb-4 mt-8 font-extrabold">
        {{ t('title') }}
      </div>
      <div class="text-secondary">
        {{ t('body-line-1') }}
      </div>
      @if (path) {
        <div
          class="text-secondary">
          {{ t('body-line-2') }}
          <a
            [routerLink]="path">
            {{ path }}
          </a>?
        </div>
      }
      <div class="flex justify-center">
        <!-- Go back -->
        <button
          aria-label="Go back"
          class="grow mt-6 mx-3 fuse-mat-button-large"
          mat-flat-button
          (click)="goBack()">
          <span>
            <mat-icon
              class="icon-size-5 mr-4"
              [svgIcon]="'heroicons_outline:arrow-left'">
            </mat-icon>
          </span>
          <span class="grow">
            {{ t('go-back') }}
          </span>
        </button>
        <!-- Take me home -->
        <a
          class="grow mt-6 mx-3 fuse-mat-button-large"
          mat-flat-button
          [color]="'primary'"
          [routerLink]="['/home']">
          {{ t('take-me-home') }}
        </a>
      </div>
    </div>

  </div>

</div>
